"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitSectionsByGroup = exports.useAvailableUnavSections = void 0;
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const useAvailableUnavSections = () => {
    const SETTINGS_GROUP = (0, util_1.t)('SETTINGS');
    const OTHER_GROUP = (0, util_1.t)('OTHER');
    const { isEmployeeCalendar, formControl, initialData, toggleSection, canEdit } = (0, unavailability_context_1.useUnavailability)();
    const categoryId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'categoryId' });
    const editingUnav = (0, util_1.isValue)(initialData?.id);
    const categoryIsTimeOff = categoryId !== use_workspace_unavailability_categories_1.AVAILABILITY_VALUE && categoryId !== use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE;
    react_1.default.useEffect(() => {
        if (isEmployeeCalendar && categoryIsTimeOff) {
            toggleSection('repeat', false);
        }
    }, [categoryId]);
    // const workspace = useWorkspace()
    // const userId = useWatch({ control: formControl, name: 'user' })
    // const shifts = useRootSelector((state) => state.shifts)
    // const periodStart = useWatch({ control: formControl, name: 'period.start' })
    // const shiftsInDay = shifts.filter(
    //   (shift) =>
    //     shift.userId === userId &&
    //     moment(periodStart).isSame(shift?.period?.start, 'day')
    // )
    // const isAvailabilityOrUnavailability =
    //   categoryId === AVAILABILITY_VALUE || categoryId === UNAVAILABILITY_VALUE
    // const categories = getWorkspaceUnavailabilityCategories(workspace)
    // const currentCategory = categories.find((cat) => cat.id === categoryId)
    // const halfDayAvailable = canUseHalfDayOption(
    //   shiftsInDay.length,
    //   isAvailabilityOrUnavailability
    // )
    // const partDayAvailable = canUsePartDayOption(
    //   workspace?.country ?? '',
    //   currentCategory?.vacation ?? false
    // )
    const staticSections = react_1.default.useMemo(() => [
        {
            id: 'whole-day',
            name: (0, util_1.t)('ALL_DAY'),
            group: SETTINGS_GROUP,
            isDisabled: (isEmployeeCalendar && editingUnav) || (!isEmployeeCalendar && !canEdit),
            // || (!halfDayAvailable && !partDayAvailable),
        },
        {
            id: 'period',
            name: (0, util_1.t)('UNAVAILABILITY_PART_OF_DAY_PERIOD'),
            visible: false,
            group: SETTINGS_GROUP,
            isDisabled: isEmployeeCalendar || (!isEmployeeCalendar && !canEdit),
        },
        {
            id: 'default-work-minutes-inclusion',
            label: (0, util_1.t)('DEFAULT_WORK_MINUTES_INCLUSION') ?? '',
            name: (0, util_1.t)('INCLUSION'),
            group: SETTINGS_GROUP,
            isDisabled: isEmployeeCalendar || (!isEmployeeCalendar && !canEdit),
        },
        {
            id: 'work-minutes-inclusion',
            name: (0, util_1.t)('INCLUSION'),
            visible: false,
            group: SETTINGS_GROUP,
            isDisabled: isEmployeeCalendar || (!isEmployeeCalendar && !canEdit),
        },
        {
            id: 'attachment',
            name: (0, util_1.t)('NF_ATTACHMENTS'),
            group: OTHER_GROUP,
            isDisabled: !isEmployeeCalendar && !canEdit,
        },
        {
            id: 'note',
            name: (0, util_1.t)('NOTE'),
            group: OTHER_GROUP,
            isDisabled: (isEmployeeCalendar && editingUnav) || (!isEmployeeCalendar && !canEdit),
        },
        {
            id: 'repeat',
            name: (0, util_1.t)('REPEAT'),
            group: OTHER_GROUP,
            isDisabled: categoryIsTimeOff || editingUnav || (!isEmployeeCalendar && !canEdit),
        },
    ], [categoryId]);
    return staticSections;
};
exports.useAvailableUnavSections = useAvailableUnavSections;
const splitSectionsByGroup = (sections) => {
    const grouped = sections.reduce((acc, section) => {
        const { group } = section;
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push(section);
        return acc;
    }, {});
    return Object.keys(grouped).map((key) => ({
        key,
        data: grouped[key],
    }));
};
exports.splitSectionsByGroup = splitSectionsByGroup;
